var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"meta-league-info"},[(_vm.props.categoryIcon)?_c('img',{staticClass:"category-icon",attrs:{"src":_vm.props.categoryIcon,"loading":"lazy"}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v("\n    "+_vm._s(_vm.props.category)+" -\n    "),_c('router-link',{attrs:{"to":{
        name: 'matchList',
        params: { sportName: encodeURIComponent(_vm.props.sportName) },
        query: { t: _vm.props.tournamentId }
      }}},[_vm._v("\n      "+_vm._s(_vm.props.tournament)+"\n    ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }